import { ComponentPropsWithRef, useMemo, useState } from 'react';
import styled from 'styled-components';

import { BaseWidgetActionsContext, BaseWidgetActionsContextType } from './BaseWidgetActions.context';

import { BaseWidgetActionsContainer } from './BaseWidgetActions.styles';

export type BaseWidgetActionsProps = ComponentPropsWithRef<'div'>;

export const BaseWidgetActions = styled(function BaseWidgetActions({ children, ...props }: BaseWidgetActionsProps) {
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  const contextValue = useMemo<BaseWidgetActionsContextType>(
    () => ({
      isMenuVisible,
      setIsMenuVisible,
    }),
    [isMenuVisible],
  );

  return (
    <BaseWidgetActionsContext.Provider value={contextValue}>
      <BaseWidgetActionsContainer
        data-is-always-visible={isMenuVisible}
        role="presentation"
        aria-label="base widget actions container"
        {...props}
      >
        {children}
      </BaseWidgetActionsContainer>
    </BaseWidgetActionsContext.Provider>
  );
})``;
